import { render, staticRenderFns } from "./test.vue?vue&type=template&id=34b92bcb&scoped=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"
import style0 from "./test.vue?vue&type=style&index=0&id=34b92bcb&prod&lang=scss&scoped=true"
import style1 from "./test.vue?vue&type=style&index=1&id=34b92bcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b92bcb",
  null
  
)

export default component.exports